import React from "react";
import { Link } from "react-router-dom";
import buttonarrowactive from "../assets/Buttonarrow.svg";

const RoundedArrowButton = ({ label = "Click Me", to = "/" }) => {
  return (
    <Link
      to={to}
      className="inline-flex font-generalsans-description items-center justify-between rounded-full px-3 py-2 font-medium transition-colors duration-300"
      style={{
        backgroundColor: "#E6E7F8",
        color: "#2C3075",
        textDecoration: "none",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#CFCFDF";
        e.currentTarget.style.color = "#2C3075";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "#E6E7F8";
        e.currentTarget.style.color = "#2C3075";
      }}
    >
      {/* Label */}
      <span className="mr-4">{label}</span>

      {/* Arrow image directly */}
      <img src={buttonarrowactive} alt="arrow" className="w-8 h-8" />
    </Link>
  );
};

export default RoundedArrowButton;